export const CLES_FILTRES_DASHBOARD = {
  commercial: 'crm.dashboard.commercial',
  periode: 'crm.dashboard.periode',
  annee: 'crm.dashboard.annee',
  mois: 'crm.dashboard.mois',
  sport: 'crm.dashboard.sport',
  financier: 'crm.dashboard.financier',
  recherche: 'crm.dashboard.recherche'
};

const stockageSession = () => {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch (_erreur) {
    return null;
  }
};

export function lireFiltreDashboard(nom, valeurParDefaut) {
  const cle = CLES_FILTRES_DASHBOARD[nom];
  if (!cle) return valeurParDefaut;
  try {
    const valeur = stockageSession()?.getItem(cle);
    return valeur == null ? valeurParDefaut : valeur;
  } catch (_erreur) {
    return valeurParDefaut;
  }
}

export function memoriserFiltresDashboard(filtres) {
  const stockage = stockageSession();
  if (!stockage) return;
  Object.entries(filtres).forEach(([nom, valeur]) => {
    const cle = CLES_FILTRES_DASHBOARD[nom];
    if (cle) stockage.setItem(cle, String(valeur ?? ''));
  });
}

export function oublierFiltresDashboard() {
  const stockage = stockageSession();
  if (!stockage) return;
  Object.values(CLES_FILTRES_DASHBOARD).forEach((cle) => stockage.removeItem(cle));
}

